import { render, staticRenderFns } from "./history-exam.vue?vue&type=template&id=626a2aa4&scoped=true"
import script from "./history-exam.vue?vue&type=script&lang=js"
export * from "./history-exam.vue?vue&type=script&lang=js"
import style0 from "./history-exam.vue?vue&type=style&index=0&id=626a2aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a2aa4",
  null
  
)

export default component.exports